<template>
  <v-container align-center align-content-center>
      <v-layout align-center align-content-center column>
          <div class="headline">
              Welcome to the NaloxoFind Contributor Page<br />
          </div>
          <v-img
            :src="require('../assets/naloxoneIcon.png')"
            class="my-3"
            contain
            height="200"
            width="200"
          ></v-img>

          <div class="ma-4">
              This page is for people who manage stationary naloxone.
              For example, naloxone in pharmacies, NaloxBoxes, or in an office building.

              These can show up on the NaloxoFind app.

              You must <a href="mailto:naloxofind.feedback@altrixmedical.com">contact us</a> to register as a contributor.

          </div>

          <br />Already a contributor?
          <v-btn :to="{name:'login'}" class="success">Login</v-btn>
          <div class="ma-4">
              More information about NaloxoFind is at <a href="https://naloxofind.com">NaloxoFind.com</a>.
          </div>
      </v-layout>
  </v-container>
</template>

<script>

  export default {
    components: {

    }
  }
</script>
